export default __webpack_public_path__ + "static/media/textlayer_original.50069e7e.jpg";